// Frans (fr), dailyApp: zelfde vorm als dailyApp.nl.ts (WP4 dagelijkse schermen).
export const appDailyFr = {
    stars: {
        tab: 'Étoiles',
        approvals: 'Valider',
        approvalsEmpty: 'Rien à valider.',
        handled: 'Traité',
        rewards: 'Récompenses',
        savingFor: 'Économise pour {goal}',
        noGoal: 'Pas encore d’objectif d’épargne',
        goalLabel: 'Objectif d’épargne de {name}',
        adjustLabel: 'Ajuster les points de {name}',
        history: 'Derniers points de {name}',
        info: 'Les enfants gagnent des étoiles avec les tâches. Ici, tu vois pour chaque enfant ce qu’il peut dépenser, pour quoi il économise et ce qui attend encore une validation. Ajoute ou modifie une récompense dans Récompenses.',
    },
    agenda: {
        title: 'Agenda',
        rides: 'Trajets',
        tools: 'Plus pour l’agenda',
        toolsTitle: 'Agenda',
        calendars: 'Connecter des calendriers',
        calendarsHint: 'Afficher ici les rendez-vous de Google, Outlook ou iCloud.',
        exportHint: 'Tous les rendez-vous en fichier calendrier (.ics).',
        trashHint: 'Restaurer les rendez-vous supprimés pendant 30 jours.',
    },
    pinboard: {
        title: 'Tableau d’affichage',
        label: 'Parties du tableau d’affichage',
        notes: 'Notes',
        messages: 'Messages',
        wishes: 'Souhaits',
    },
    kids: {
        title: 'Enfants',
        label: 'Parties pour les enfants',
        learning: 'Objectifs d’apprentissage',
        growth: 'Croissance',
        school: 'École',
        filter: 'Choisir un enfant',
        all: 'Tous les enfants',
    },
    chores: {
        label: 'Type de tâches',
        series: 'Tâches fixes',
        chores: 'Tâches ménagères',
    },
    recipes: {
        more: 'Charger plus',
        shown: '{shown} sur {total}',
        pick: 'Choisis une recette dans la liste.',
        filter: 'Quelles recettes',
    },
    menu: {
        past: {
            one: '{count} jour plus tôt cette semaine',
            other: '{count} jours plus tôt cette semaine',
        },
        showPast: 'Afficher',
        hidePast: 'Masquer',
        suggestions: 'Suggestions',
        suggestionsCount: 'Suggestions ({count})',
        shelfHint: 'Fais glisser une recette sur un jour.',
    },
};
//# sourceMappingURL=dailyApp.fr.js.map